<template>
	<!-- <div class="my-order" @touchstart="fnstart" ref="container"> -->
	<div class="my-order" ref="container">
		<!-- <div class="header bg-color-red">
			<div class="picTxt acea-row row-between-wrapper">
				<div class="text">
					<div class="name">订单信息</div>
					<div>
						累计订单：{{ orderData.leiji || 0 }} 总消费：￥{{orderData.xiaofei || 0}}
					</div>
				</div>
				<div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
			</div>
		</div> -->
		<div class="headTopBox"
			style="position: sticky;top: 0;left: 0;height: 50px;display: flex;justify-content: space-between;align-items: center;padding: 0 20px;  background-color: #fff;">
			<div class="fanhui" style="width: 20px;" @click="$router.go(-1)">
				<img style="width: 18px; height: 18px;" src="@assets/images/back.png" />
			</div>
			<div style="font-size: 18px;font-weight: 550;">有效订单</div>
			<div style="width: 20px;"></div>
		</div>
		<div class="nav" style="height: 1.2rem;margin-top: 0.1rem">
			<!-- <div style="height: 1rem;line-height: 1rem;padding-left: 20px;border-bottom: 1px solid #e8e8e8;">
				累计订单：{{ orderData.leiji || 0 }} <span
					style="padding-left: 0.2rem;"></span>总消费：￥{{orderData.xiaofei || 0}}
			</div> -->
			<div class=" acea-row row-around" style="padding: 0.2rem ;">
				<div class="item" style="padding: 0;">
					<div>今日收入</div>
					<div class="num" style="color:#e93323;">{{ orderData.jinri || 0 }}</div>
				</div>
				<div class="line" style="width: 1px; height: 0.8rem; background-color:  #e8e8e8;"></div>
				<div class="item" style="padding: 0;">
					<div>今日有效</div>
					<div class="num" style="color:#e93323;">{{ orderData.jinridd || 0 }}</div>
				</div>
				<div class="line" style="width: 1px; height: 0.8rem; background-color:  #e8e8e8;"></div>
				<div class="item" style="padding: 0;">
					<div>今日转换率</div>
					<div class="num" style="color:#e93323;">{{ orderData.zongzhuanhua || 0 }}</div>
				</div>

				<!--       
      <div
        class="item"
        :class="{ on: type === 2 }"
        @click="$router.replace({ path: '/order/list/2' })"
      >
        <div>待收货</div>
        <div class="num">{{ orderData.received_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 3 }"
        @click="$router.replace({ path: '/order/list/3' })"
      >
        <div>待评价</div>
        <div class="num">{{ orderData.evaluated_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 4 }"
        @click="$router.replace({ path: '/order/list/4' })"
      >
        <div>已完成</div>
        <div class="num">{{ orderData.complete_count || 0 }}</div>
      </div> -->
			</div>
		</div>
		<div class="list" style="background-color: #fff;overflow: hidden;border-radius:0.06rem 0.06rem 0 0;">
			<div class="item"
				style="font-size: 14px;border-bottom: 1px solid #ccc;overflow: hidden;height:40px;line-height:40px;margin-bottom:0;">
				<ul>
					<li style="width:20%;text-align:center;">姓名</li>
					<li style="width:20%;text-align:center;">金额</li>
					<li style="width:20%;text-align:center;">佣金</li>
					<li style="width:20%;text-align:center;">状态</li>
					<li style="width:20%;text-align:center;">时间</li>

				</ul>
			</div>
			<div class="item"
				style="border-bottom: 1px solid #e8e8e8;overflow: hidden;height:40px;line-height:40px;margin-bottom:0;font-size: 14px;"
				v-for="order in orderList" :key="order.id">
				<ul>
					<li style="width:20%;text-align:center;">{{ order.des }}</li>
					<li style="width:20%;text-align:center;">{{ order.money }}</li>
					<li style="width:20%;text-align:center;">{{ order.dl_money }}</li>
					<li style="width:20%;text-align:center;padding-top:8px;">
						<div v-if="order.status === 0"
							style="border-radius:4px;padding-left:5px;padding-right:5px;height:24px;line-height: 24px;background:RGB(192, 192, 192);color:#fff;">
							未支付</div>
						<div v-if="order.status === 1"
							style="border-radius:4px;padding-left:5px;padding-right:5px;height:24px;line-height: 24px;background:RGB(255, 153, 18);color:#fff;">
							已支付</div>
					</li>
					<li style="width:20%;text-align:center;">{{ order.shijian }}</li>

				</ul>
			</div>
		</div>
		<div class="noCart" v-if="orderList.length === 0 && page > 1">
			<div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
		</div>
		<Loading :loaded="loadend" :loading="loading"></Loading>
		<Payment v-model="pay" :types="payType" @checked="toPay" :balance="userInfo.now_money"></Payment>
		<GeneralWindow :generalActive="generalActive" @closeGeneralWindow="closeGeneralWindow"
			:generalContent="generalContent"></GeneralWindow>
	</div>
</template>
<script>
	import {
		getOrderDatas,
		getOrderLists
	} from "@api/order";
	import {
		cancelOrderHandle,
		payOrderHandle,
		takeOrderHandle
	} from "@libs/order";
	import Loading from "@components/Loading";
	import Payment from "@components/Payment";
	import {
		mapGetters
	} from "vuex";
	import {
		isWeixin
	} from "@utils";
	import GeneralWindow from "@components/GeneralWindow";

	const STATUS = [
		"待付款",
		"待发货",
		"待收货",
		"待评价",
		"已完成",
		"",
		"",
		"",
		"",
		"待付款"
	];

	const NAME = "MyOrders";

	export default {
		name: NAME,
		data() {
			return {
				offlinePayStatus: 2,
				orderData: {},
				type: parseInt(this.$route.params.type) || 0,
				page: 1,
				limit: 30,

				orderList: [],
				pay: false,
				isTop: true,
				loadTitle: "",
				loading: false,
				loadend: false,
				payType: ["yue", "weixin"],
				from: isWeixin() ? "weixin" : "weixinh5",
				generalActive: false,
				generalContent: {
					promoterNum: "",
					title: ""
				},

				startX: '',
				endX: '',
				startY: '',
				endY: '',
				moveDistance: 0,
				tipText: '下拉刷新',
				el: null
			};
		},
		components: {
			Loading,
			Payment,
			GeneralWindow
		},
		computed: mapGetters(["userInfo"]),
		watch: {
			$route(n) {
				if (n.name === NAME) {
					const type = parseInt(this.$route.params.type) || 0;
					if (this.type !== type) {
						this.changeType(type);
					}
					this.getOrderData();
				}
			}
		},
		methods: {
			// 下拉刷新开始
			/**
			 * 绑定touch事件
			 */
			bindTouchEvent() {
				let that = this;
				this.el.addEventListener('touchstart', this._touchStart);

				this.el.addEventListener('touchmove', this._touchMove);

				this.el.addEventListener('touchend', this._touchEnd)
			},
			/**
			 * 开始下拉的监听 这里主要是记录下初始坐标 下拉只需记录y即可(这里方便以后测其他的使用,也记录了 x)
			 * @param e 下拉事件
			 */
			_touchStart(e) {
				this.tipText = '下拉刷新1';
				
					// this.getOrderData();
					// this.orderList = [];
					// this.page = 1;
					// this.loaded = false;
					// this.loading = false;
					// this.getOrderList();
					
				 let touch = e.changedTouches[0];
				// this.tipText = '下拉刷新';
				this.startX = touch.clientX;
				this.startY = touch.clientY;
			},
			/**
			 * 下拉过程的监听 这里记录下移动的距离
			 * @param e
			 */
			_touchMove(e) {
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
				        //首先判断有没有滚动条，如果有，下拉刷新就不能启用。
				      if (scrollTop > 0) return
				 
				      let move = e.targetTouches[0].clientY - this.startY
				        //判断手指滑动的距离，只有为正数才代表用户下拉了。
						//alert(move)
				      if (move > 0) {
						  this.getOrderData();
						  this.orderList = [];
						  this.page = 1;
						  this.loaded = false;
						  this.loading = false;
						  this.getOrderList();
				}
				// let touch = e.changedTouches[0];
				// //获取下拉的距离
				// let _move = touch.clientY - this.startY;
				// //这里主要是让内容区随着下拉操作而往下滚动
				// //_move>0是指往下滑动(下拉),_move<100是给一个上限,不然一直下拉的话整个内容区就会随着下拉距离一直增大,用户体验不是很好
				// //这里下拉操作主要是显示出顶上的一层tipText
				// if (_move > 0 && _move < 100) {
				// 	this.el.style.marginTop = _move + 'px';
				// 	//记录下下拉的距离
				// 	this.moveDistance = touch.clientY - this.startY;
				// 	if (_move > 100) {
				// 		this.tipText = '松开即可刷新'
				// 	}
				// }else{
				// 	this.getOrderList();
				// }
			},
			/**
			 * 下拉动作结束(松开手指)监听
			 * @param e
			 * @private
			 */
			_touchEnd(e) {
				// let touch = e.changedTouches[0];
				// this.endX = touch.clientX;
				// this.endY = touch.clientY;
				// let that = this;
				// if (this.moveDistance > 100) {
				// 	this.tipText = '数据加载中...';
				// 	//调用父组件的加载数据的方法
				// 	//这时候要在父组件的数据加载完成后,才将div还原,所以这里把resolve传进了父组件中,也可以采取其他方法
				// 	this.getOrderList();
				// } else {
				// 	this._resetBox();
				// }
			},
			/**
			 * 重置视图
			 * 这里的操作主要是将移动的距离还原,用一个定时器慢慢将marginTop的值减回去直到0为止
			 */
			_resetBox() {
				let that = this;
				if (this.moveDistance > 0) {
					let timer = setInterval(function() {
						that.el.style.marginTop = --that.moveDistance + 'px';
						if (Number(that.el.style.marginTop.split('px')[0]) <= 0) clearInterval(timer);
					}, 1)
				}
			},
			// 下拉刷新结束
			// 下拉刷新结束
			setOfflinePayStatus: function(status) {
				var that = this;
				that.offlinePayStatus = status;
				if (status === 1) {
					if (that.payType.indexOf("offline") < 0) {
						that.payType.push("offline");
					}
				}
			},
			fnstart(ev) {
				this.$refs["container"].style.top = 0;
				this.scroolTop = 0;
				if (!this.isTop) {
					return false;
				}
				document.ontouchmove = this.fnmove;
				document.ontouchend = this.fnEnd;

			},
			fnmove(ev) {
				console.log('1');
				let that = this;
				that.loading = true;
				this.T = ev.changedTouches[0].pageY - this.scroolTop;
				if (this.scale > 0.12) {
					this.scale = 1 - this.T / 200;
				} else {
					this.scale = 0.12;
				}
				console.log('1');
				this.$refs["container"].style.top = 0;
			},
			fnEnd(ev) {
				console.log('1');
				let that = this;
				that.loading = false;
				that.loadend = false;
				document.ontouchmove = null;
				document.ontouchend = null;
				console.log('1');
				setTimeout((that) => {

					this.$refs["container"].style.top = 0;
					this.$refs["container"].style.transition = ".3s ease all";
					this.$refs["container"].addEventListener("transitionend", () => {
						this.$refs["container"].style.transition = null;
						//this.User();
						that.loading = false;
						that.loadend = false;
					});
					this.getOrderData();
					this.orderList = [];
					this.page = 1;
					this.loaded = false;
					this.loading = false;
					this.getOrderList();
					//this.User();
				}, 500);
			},
			handleScroll() {
				const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

				if (scrollPosition === 0 && !this.isTop) {
					this.isTop = true;
				} else if (scrollPosition > 0 && this.isTop) {
					this.isTop = false;
				}
			},
			getOrderData() {
				getOrderDatas().then(res => {
					this.orderData = res.data;
				});
			},
			takeOrder(order) {
				this.$dialog.loading.open("正在加载中");
				takeOrderHandle(order.order_id)
					.then(res => {
						if (
							(res.data.gain_integral != "0.00" &&
								res.data.gain_coupon != "0.00") ||
							(res.data.gain_integral > 0 && res.data.gain_coupon > 0)
						) {
							this.$dialog.loading.close();
							this.generalActive = true;
							this.generalContent = {
								promoterNum: `恭喜您获得${res.data.gain_coupon}元优惠券以及${
                res.data.gain_integral
              }积分，购买商品时可抵现哦～`,
								title: "恭喜您获得优惠礼包"
							};
							return;
						} else if (
							res.data.gain_integral != "0.00" ||
							res.data.gain_integral > 0
						) {
							this.$dialog.loading.close();
							this.generalActive = true;
							this.generalContent = {
								promoterNum: `恭喜您获得${
                res.data.gain_integral
              }积分，购买商品时可抵现哦～`,
								title: "赠送积分"
							};
							return;
						} else if (
							res.data.gain_coupon != "0.00" ||
							res.data.gain_coupon > 0
						) {
							this.$dialog.loading.close();
							this.generalActive = true;
							this.generalContent = {
								promoterNum: `恭喜您获得${
                res.data.gain_coupon
              }元优惠券，购买商品时可抵现哦～`,
								title: "恭喜您获得优惠券"
							};
							return;
						} else {
							this.$dialog.loading.close();
							this.$dialog.success("收货成功");
						}
						this.getOrderData();
						this.orderList = [];
						this.page = 1;
						this.loaded = false;
						this.loading = false;
						this.getOrderList();
					})
					.catch(err => {
						this.$dialog.loading.close();
						this.$dialog.error(err.msg);
					});
			},
			closeGeneralWindow(msg) {
				this.generalActive = msg;
				this.reload();
				this.getOrderData();
			},
			reload() {
				this.changeType(this.type);
			},
			changeType(type) {
				this.type = type;
				this.orderList = [];
				this.page = 1;
				this.loaded = false;
				this.loading = false;
				this.getOrderList();
			},
			getOrderList() {
				console.log('1');
				if (this.loading || this.loaded) return;
				this.loading = true;
				const {
					page,
					limit,
					type
				} = this;
				getOrderLists({
					page,
					limit,
					type
				}).then(res => {
					this.orderList = this.orderList.concat(res.data);
					this.page++;
					this.loaded = res.data.length < this.limit;
					this.loading = false;
					this.tipText = '下拉刷新2';
				});
			},
			getStatus(order) {
				return STATUS[order._status._type];
			},
			cancelOrder(order) {
				cancelOrderHandle(order.order_id)
					.then(() => {
						this.getOrderData();
						this.orderList.splice(this.orderList.indexOf(order), 1);
					})
					.catch(() => {
						this.reload();
					});
			},
			paymentTap: function(order) {
				var that = this;
				if (
					!(
						order.combination_id > 0 ||
						order.bargain_id > 0 ||
						order.seckill_id > 0
					)
				) {
					that.setOfflinePayStatus(order.offlinePayStatus);
				}
				this.pay = true;
				this.toPay = type => {
					payOrderHandle(order.order_id, type, that.from)
						.then(() => {
							const type = parseInt(this.$route.params.type) || 0;
							that.changeType(type);
							that.getOrderData();
						})
						.catch(res => {
							if (res.status === "WECHAT_H5_PAY")
								return that.$router.push({
									path: "/order/status/" + order.order_id + "/5"
								});
							const type = parseInt(that.$route.params.type) || 0;
							that.changeType(type);
							that.getOrderData();
						});
				};
			},
			toPay() {}
		},
		mounted() {
			this.el = document.querySelector(".my-order");
			this.bindTouchEvent();

			this.getOrderData();
			this.getOrderList();
			this.$scroll(this.$refs.container, () => {
				!this.loading && this.getOrderList();
			});
			window.addEventListener('scroll', this.handleScroll);

		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		}
	};
</script>

<style scoped>
	.noCart {
		margin-top: 0.17rem;
		padding-top: 0.1rem;
	}

	ul li {
		float: left;
	}

	.noCart .pictrue {
		width: 4rem;
		height: 3rem;
		margin: 0.7rem auto 0.5rem auto;
	}

	.noCart .pictrue img {
		width: 100%;
		height: 100%;
	}
</style>